import { NgModule } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { configureUserPool } from '@callrail/looky/anubis/login/shared';
import { AppModule } from './app/app.module';

configureUserPool()
  .then(() => platformBrowserDynamic().bootstrapModule<NgModule>(AppModule))
  // eslint-disable-next-line no-console
  .catch(console.error);
